import { BaseNodeModel } from "@/models/nodes/BaseNodeModel";

import type { DocumentModel } from "@/models/DocumentModel";
import type { NodeModel, NodeId } from "@/models/nodes/types";
import type { VisitableNode, NodeVisitor } from "@/models/nodes/visitors/NodeVisitor";
import type { InlineNodeProps, InlineNodeConstructorProps } from "@corca/data";

export class InlineNodeModel extends BaseNodeModel implements VisitableNode {
  static type = "inline" as const;

  type = InlineNodeModel.type;

  protected fillRequiredProps(props: InlineNodeConstructorProps): InlineNodeProps {
    return props;
  }

  prepareUpdate(skipTransform?: boolean): void {
    super.prepareUpdate(skipTransform);
    this.parent?.prepareUpdate();
  }

  static create(doc: DocumentModel, nodes?: NodeModel[], id?: NodeId) {
    return new InlineNodeModel(doc, id, {}, nodes);
  }

  get isEmpty(): boolean {
    return this.nodes.length === 0;
  }

  accept<R>(visitor: NodeVisitor<R>): R {
    return visitor.visitInlineNode(this);
  }
}
